//@flow
import React from 'react';
import Foundation from 'components/organisms/foundation';
import FoundationMobile from 'components/organisms/foundation/foundationMobile';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';

const MusicFoundation = (props: Props) => {
  const { data } = props;
  const { cmsDetailsData } = data;
  const show_desktop_overlay_button = props.data.show_desktop_overlay_button;
  const { isMobile, height } = useViewport();
  if (!props.data) {
    return null;
  }
  return (
    <div
      className={'main-container'}
      style={isMobile ? { height } : {}}
      id={'foundation'}
    >
      {!isMobile ? (
        <Foundation
          data={data.foundationData}
          cmsDetailsData={cmsDetailsData}
          showOverlay={show_desktop_overlay_button}
          type={data.type}
        />
      ) : (
        <FoundationMobile
          data={data.foundationData}
          cmsDetailsData={cmsDetailsData}
          showOverlay={show_desktop_overlay_button}
          type={data.type}
        />
      )}
    </div>
  );
};
export default MusicFoundation;
